// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__FYlQK","header":"ClearentDisclaimer_header__2bSoa","inner":"ClearentDisclaimer_inner__2enXj"};